import { useRef } from "react";
import "../styles/Input.css";
import { shouldRenderAutoRequiredMark } from "../utils/requiredLabel";
import { CNIC_FORMAT, formatCnicValue } from "../utils/pakistanCnic";

const CnicInput = ({
  label,
  placeholder = CNIC_FORMAT,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  disabled = false,
  className = "",
  required = true,
  setFieldValue,
}) => {
  const inputRef = useRef(null);
  const shouldShowAutoRequired = shouldRenderAutoRequiredMark(label, required);

  const handleChange = (event) => {
    const formattedValue = formatCnicValue(event.target.value);

    if (setFieldValue) {
      setFieldValue(name, formattedValue);
      return;
    }

    if (onChange) {
      event.target.value = formattedValue;
      onChange(event);
    }
  };

  return (
    <div className={`input_wrapper ${className}`}>
      <div
        className={`input_container ${disabled ? "disabled" : ""}`}
        style={{ position: "relative" }}
      >
        <label style={{ display: "flex", gap: "5px" }}>
          {label}
          {shouldShowAutoRequired && (
            <span style={{ color: "red", fontSize: "13px" }}>*</span>
          )}
        </label>

        <input
          ref={inputRef}
          type="text"
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={15}
          className={`${disabled ? "disabled-component" : ""}`}
        />
      </div>

      {touched && error && (
        <div
          className="error-message"
          style={{
            color: "#ff0000de",
            fontSize: "12px",
            marginTop: "3px",
            marginLeft: "5px",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default CnicInput;
